import UbicacionSelector from './UbicacionSelector'
import './UbicacionSelector.css'

export default UbicacionSelector
export { UbicacionSelector }